import script from "./Speakers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Speakers.vue?vue&type=script&setup=true&lang=ts"

import "./Speakers.vue?vue&type=style&index=0&id=65e8cf1d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e8cf1d"]])

export default __exports__